import { render, staticRenderFns } from "./ekko.header-nav.vue?vue&type=template&id=2b0dbf28&scoped=true&"
import script from "./ekko.header-nav.vue?vue&type=script&lang=ts&"
export * from "./ekko.header-nav.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.header-nav.vue?vue&type=style&index=0&id=2b0dbf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0dbf28",
  null
  
)

export default component.exports